<template>
  <div class="form-page">
    <div class="page-header">
      <h1>Cadastro de Modelo de Relatório de Atividades</h1>
      <p>Configuração do modelo e dos campos que compõem o formulário operacional.</p>
    </div>

    <div class="form-card">
      <h2>Dados Gerais do Modelo</h2>

      <div class="form-grid cols-2">
        <div class="form-group">
          <label>Código do Modelo</label>
          <input v-model="modelo.cdmodelo" type="text" placeholder="Ex.: RELAT_ATV_PADRAO" />
        </div>

        <div class="form-group">
          <label>Nome do Modelo</label>
          <input v-model="modelo.nmmodelo" type="text" placeholder="Ex.: Relatório de Atividades Padrão" />
        </div>

        <div class="form-group">
          <label>Tipo do Modelo</label>
          <select v-model="modelo.tpmodelo">
            <option value="">Selecione</option>
            <option value="ATV">Relatório de Atividades</option>
            <option value="ATV_COMP">Relatório de Atividades Complementar</option>
          </select>
        </div>

        <div class="form-group">
          <label>Origem dos Dados</label>
          <select v-model="modelo.origemDados">
            <option value="">Selecione</option>
            <option value="M">Manual</option>
            <option value="A">Automática</option>
            <option value="X">Mista</option>
          </select>
        </div>

        <div class="form-group">
          <label>Título do Documento</label>
          <input v-model="modelo.titulo" type="text" placeholder="Título exibido no relatório" />
        </div>

        <div class="form-group">
          <label>Ordem de Exibição</label>
          <input v-model="modelo.ordem" type="number" min="0" />
        </div>
      </div>

      <div class="form-group">
        <label>Descrição / Instruções</label>
        <textarea
          v-model="modelo.descricao"
          rows="4"
          placeholder="Descreva a finalidade do modelo e orientações para preenchimento"
        ></textarea>
      </div>

      <div class="check-grid">
        <label><input v-model="modelo.ckativo" type="checkbox" /> Modelo ativo</label>
        <label><input v-model="modelo.ckassinatura" type="checkbox" /> Permite assinatura digital</label>
        <label><input v-model="modelo.ckanexos" type="checkbox" /> Permite anexos</label>
        <label><input v-model="modelo.ckgerarPdf" type="checkbox" /> Permite geração em PDF</label>
      </div>
    </div>

    <div class="form-card">
      <h2>Filtros e Aplicação</h2>

      <div class="check-grid">
        <label><input v-model="modelo.ckporperiodo" type="checkbox" /> Utiliza período</label>
        <label><input v-model="modelo.ckporestabelecimento" type="checkbox" /> Filtrar por estabelecimento</label>
        <label><input v-model="modelo.ckporsim" type="checkbox" /> Filtrar por SIM</label>
        <label><input v-model="modelo.ckporresponsavel" type="checkbox" /> Filtrar por responsável</label>
      </div>

      <div class="form-grid cols-2">
        <div class="form-group">
          <label>Texto Padrão de Abertura</label>
          <textarea
            v-model="modelo.txtabertura"
            rows="4"
            placeholder="Texto opcional exibido na abertura do relatório"
          ></textarea>
        </div>

        <div class="form-group">
          <label>Texto Padrão de Encerramento</label>
          <textarea
            v-model="modelo.txtencerramento"
            rows="4"
            placeholder="Texto opcional exibido ao final do relatório"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="form-card">
      <div class="section-title">
        <h2>Itens / Campos do Modelo</h2>
        <button type="button" class="btn btn-primary" @click="adicionarCampo">
          + Adicionar Campo
        </button>
      </div>

      <div
        v-for="(campo, index) in modelo.campos"
        :key="campo.uid"
        class="campo-card"
      >
        <div class="campo-card-header">
          <strong>Campo {{ index + 1 }}</strong>
          <button type="button" class="btn btn-danger" @click="removerCampo(index)">
            Remover
          </button>
        </div>

        <div class="form-grid cols-3">
          <div class="form-group">
            <label>Código do Campo</label>
            <input v-model="campo.cdcampo" type="text" placeholder="Ex.: OBS_GERAIS" />
          </div>

          <div class="form-group">
            <label>Nome Interno</label>
            <input v-model="campo.nmcampo" type="text" placeholder="Ex.: obsGerais" />
          </div>

          <div class="form-group">
            <label>Rótulo</label>
            <input v-model="campo.label" type="text" placeholder="Ex.: Observações Gerais" />
          </div>

          <div class="form-group">
            <label>Tipo do Campo</label>
            <select v-model="campo.tpcampo">
              <option value="">Selecione</option>
              <option value="text">Texto curto</option>
              <option value="textarea">Texto longo</option>
              <option value="date">Data</option>
              <option value="number">Número</option>
              <option value="boolean">Sim / Não</option>
              <option value="select">Seleção</option>
              <option value="checklist">Checklist</option>
              <option value="anexo">Anexo</option>
              <option value="assinatura">Assinatura</option>
            </select>
          </div>

          <div class="form-group">
            <label>Ordem</label>
            <input v-model="campo.ordem" type="number" min="0" />
          </div>

          <div class="form-group">
            <label>Largura</label>
            <select v-model="campo.largura">
              <option value="100">100%</option>
              <option value="50">50%</option>
              <option value="33">33%</option>
              <option value="25">25%</option>
            </select>
          </div>
        </div>

        <div class="check-grid">
          <label><input v-model="campo.obrigatorio" type="checkbox" /> Obrigatório</label>
          <label><input v-model="campo.visivelListagem" type="checkbox" /> Exibir na consulta</label>
          <label><input v-model="campo.preenchimentoAutomatico" type="checkbox" /> Preenchimento automático</label>
        </div>

        <div class="form-grid cols-2">
          <div class="form-group">
            <label>Fonte de Dados / Regra</label>
            <input
              v-model="campo.fonteDados"
              type="text"
              placeholder="Ex.: TOTAL_VISTORIAS, NOME_ESTABELECIMENTO, OBS_ATIVIDADE"
            />
          </div>

          <div class="form-group">
            <label>Valor Padrão</label>
            <input v-model="campo.valorPadrao" type="text" placeholder="Opcional" />
          </div>
        </div>

        <div class="form-group" v-if="campo.tpcampo === 'select' || campo.tpcampo === 'checklist'">
          <label>Opções</label>
          <textarea
            v-model="campo.opcoes"
            rows="3"
            placeholder="Informe uma opção por linha"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="btn btn-secondary">Cancelar</button>
      <button type="button" class="btn btn-primary">Salvar Modelo</button>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';

function novoCampo() {
  return {
    uid: Date.now() + Math.random(),
    cdcampo: '',
    nmcampo: '',
    label: '',
    tpcampo: '',
    ordem: 0,
    largura: '100',
    obrigatorio: false,
    visivelListagem: true,
    preenchimentoAutomatico: false,
    fonteDados: '',
    valorPadrao: '',
    opcoes: '',
  };
}

const modelo = reactive({
  cdmodelo: '',
  nmmodelo: '',
  tpmodelo: '',
  origemDados: '',
  titulo: '',
  ordem: 0,
  descricao: '',
  ckativo: true,
  ckassinatura: true,
  ckanexos: true,
  ckgerarPdf: true,
  ckporperiodo: true,
  ckporestabelecimento: true,
  ckporsim: true,
  ckporresponsavel: true,
  txtabertura: '',
  txtencerramento: '',
  campos: [
    {
      uid: 1,
      cdcampo: 'OBJETIVO',
      nmcampo: 'objetivo',
      label: 'Objetivo',
      tpcampo: 'textarea',
      ordem: 1,
      largura: '100',
      obrigatorio: true,
      visivelListagem: true,
      preenchimentoAutomatico: false,
      fonteDados: '',
      valorPadrao: '',
      opcoes: '',
    },
    {
      uid: 2,
      cdcampo: 'CONCLUSAO',
      nmcampo: 'conclusao',
      label: 'Conclusão',
      tpcampo: 'textarea',
      ordem: 2,
      largura: '100',
      obrigatorio: false,
      visivelListagem: true,
      preenchimentoAutomatico: false,
      fonteDados: '',
      valorPadrao: '',
      opcoes: '',
    },
  ],
});

function adicionarCampo() {
  modelo.campos.push(novoCampo());
}

function removerCampo(index) {
  modelo.campos.splice(index, 1);
}
</script>

<style scoped>
.form-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h1 {
  margin: 0 0 6px;
  font-size: 28px;
}

.page-header p {
  margin: 0;
  color: #666;
}

.form-card {
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}

.form-card h2 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 20px;
}

.section-title,
.campo-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.form-grid {
  display: grid;
  gap: 14px;
  margin-bottom: 14px;
}

.form-grid.cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.form-grid.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  border: 1px solid #cfcfcf;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #3b82f6;
}

.check-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 14px;
}

.check-grid label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.campo-card {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  padding: 16px;
  margin-top: 16px;
  background: #fafafa;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  border: 0;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111827;
}

.btn-danger {
  background: #dc2626;
  color: #fff;
}

@media (max-width: 900px) {
  .form-grid.cols-2,
  .form-grid.cols-3,
  .check-grid {
    grid-template-columns: 1fr;
  }
}
</style>